import React, { useRef, useEffect, useState } from 'react';
import { useDispatch, useSelector, Provider } from "react-redux";
import mapboxgl from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css'
import {
  fetchMapData,
  changeMapZoom,
  updateMapProperty,
  removeRoute,
  fetchAnchorageGeoData,
} from '../../redux/action/map-data.action';
import { getPopupContent, createMissingImage, getVesselScale, allVesselTypes, getVesselColorByType } from './utils';
import * as turf from '@turf/turf'
import { RulerControl } from 'mapbox-gl-controls';
import ReactDOM from 'react-dom';
import PreviewProperty from './preview-property.component';
import { store } from '../root.component'
import { fullyLoaded, updateUiProperty } from '../../redux/action/ui.action';
import { fetchShipyardsData } from "../../redux/action/map-data.action";
import { fetchShipyardsGeoData } from "../../redux/action/map-data.action";
import { updateFilter } from '../../redux/action/filter.action';

const getParams = (location, name) => {
  const searchParams = new URLSearchParams(location.search);
  let ret = {};
  ret[name] = searchParams.get(name) || "";
  return ret;
}

export const MapContainer = ({ filters }) => {
  const dispatch = useDispatch();
  const mapContainerRef = useRef(null);
  mapboxgl.accessToken = "pk.eyJ1IjoiY2hlbi1tYXJpdGltZWRhdGFzeXN0ZW1zLWNvbSIsImEiOiJjajNlNjduMzkwMHBhMzFzMjJnMGlpZmhvIn0.buGEUU37tesHnaWbKZET1A";
  let vesselPosition = useSelector(state => state.mapData.vesselPosition);
  let vesselPolygon = useSelector(state => state.mapData.vesselPolygon);
  let vesselRoute = useSelector(state => state.mapData.vesselRoute);
  let vesselTracking = useSelector(state => state.mapData.vesselTracking);
  let shipyards = useSelector(state => state.mapData.shipyards);
  let shipyardsWatchList = useSelector(state => state.mapData.shipyardsWatchList);
  let newBuildShipyards = useSelector(state => state.mapData.newBuildShipyards);
  let requestSerial = useSelector(state => state.mapData.requestSerial);
  let searchRequestSerial = useSelector(state => state.mapData.searchRequestSerial);
  let vesselTrackingsRequestSerial = useSelector(state => state.mapData.vesselTrackingsRequestSerial);
  let filter = useSelector(state => state.filter);
  let ui = useSelector(state => state.ui);
  let fleet = useSelector(state => state.fleet);
  let currentSearchResult = useSelector(state => state.mapData.currentSearchResult);
  let currentFeature = useSelector(state => state.mapData.currentFeature);
  let baseLayer = useSelector(state => state.ui.baseLayer);
  let mainTrackings = useSelector(state => state.mapData.mainTrackings);
  let currentMailingList = useSelector(state => state.mapData.currentMailingList);
  let currentMailingListSerial = useSelector(state => state.mapData.currentMailingListSerial);
  let currentFilterSerial= useSelector(state => state.filter.filterSerial);
  let zoom = useSelector(state => state.mapData.zoom);
  let mapRefresher = useSelector(state => state.ui.mapRefresher);
  let currentTab = useSelector(state => state.ui.currentTab);
  let fullyLoad = useSelector(state => state.ui.fullyLoad);
  let flyToPosition = useSelector(state => state.mapData.flyToPosition);
  let reloadMapDataSeq = useSelector(state => state.mapData.reloadMapDataSeq);
  let underwater = useSelector(state => state.mapData.underwater);
  let waste = useSelector(state => state.mapData.waste);
  let steel = useSelector(state => state.mapData.steel);
  let safety = useSelector(state => state.mapData.safety);
  let electrical = useSelector(state => state.mapData.electrical);
  let environmental = useSelector(state => state.mapData.environmental);
  let flagState = useSelector(state => state.mapData.flagState);
  let classification = useSelector(state => state.mapData.classification);
  let workshop = useSelector(state => state.mapData.workshop);
  let warehouse = useSelector(state => state.mapData.warehouse);
  let docking_consulting = useSelector(state => state.mapData.docking_consulting);
  let port = useSelector(state => state.mapData.port);
  let engine = useSelector(state => state.mapData.engine);
  let allShipyards = useSelector(state => state.mapData.allShipyards);
  let portService = useSelector(state => state.mapData.portService);
  let anchorageAreaPolygon = useSelector(state => state.mapData.anchorageAreaPolygon);


  let mapDiv = document.getElementById("main-map");
  let mapCanvas = document.getElementsByClassName('mapboxgl-canvas')[0];
  let companyAreas = useSelector(state => state.mapData.companyAreaPolygon);
  let companyDocks = useSelector(state => state.mapData.docksPolygon);
  let vesselsInAnchorage = useSelector(state => state.mapData.vesselsInAnchorage);
  let portSearchId = useSelector(state => state.filter.portId);
  let precipitation = useSelector(state => state.ui.precipitation);
  let company = useSelector(state => state.user.company);
  let companyId = useSelector(state => state.user.companyId);
  let shipyardCoordinate = useSelector(state => state.mapData.shipyardCoordinate)
  let currentView = useSelector(state => state.ui.currentView);
  let vesselDetail = useSelector(state => state.vessel.detail);

  
  const mapRef = useRef(null);
  const echartsLayerRef = useRef(null);
  const filterRef = useRef(null);
  const uiRef = useRef(null);
  const fleetRef = useRef(null);
  const currentFeatureRef = useRef(null);
  const currentCompanyId = useRef(null);
  const currentCompany = useRef(null);
  const currentSelectedTab = useRef(null);
  const currentFullyLoaded = useRef(null);
  
  const detailPopupRef = useRef(null);
  
  let [lastFeature, setLastFeature] = useState({});
  
  const densitySwitchZoomLevel = 5.0;
  const flyToZoomLevel = 12.0;
  
  const pulsingSize = 200;
  
  
   
  let pulsingDot = {
    width: pulsingSize,
    height: pulsingSize,
    data: new Uint8Array(pulsingSize * pulsingSize * 4),

    // get rendering context for the map canvas when layer is added to the map
    onAdd: function () {
      let canvas = document.createElement('canvas');
      canvas.width = this.width;
      canvas.height = this.height;
      this.context = canvas.getContext('2d');
    },

    // called once before every frame where the icon will be used
    render: function () {
      let duration = 1500;
      let t = (performance.now() % duration) / duration;

      let radius = (pulsingSize / 2) * 0.3;
      let outerRadius = (pulsingSize / 2) * 0.7 * t + radius;
      let context = this.context;

      // draw outer circle
      context.clearRect(0, 0, this.width, this.height);
      context.beginPath();
      context.arc(
        this.width / 2,
        this.height / 2,
        outerRadius,
        0,
        Math.PI * 2
      );
      context.fillStyle = 'rgba(0, 150,	136,' + (1 - t) + ')';
      context.fill();

      // draw inner circle
      context.beginPath();
      context.arc(
        this.width / 2,
        this.height / 2,
        radius,
        0,
        Math.PI * 2
      );
      context.fillStyle = 'rgba(0, 150,	136, 0.5)';
      context.lineWidth = 2 + 4 * (1 - t);
      context.fill();

      // update this image's data with data from the canvas
      this.data = context.getImageData(
        0,
        0,
        this.width,
        this.height
      ).data;

      // continuously repaint the map, resulting in the smooth animation of the dot
      mapRef.current.triggerRepaint();

      // return `true` to let the map know that the image was updated
      return true;
    }
  };

  let mapChangeEvent = (mmaapp) => {

    if (!mapRef.current.isStyleLoaded()) {
      return
    }

    if (mmaapp.getZoom() >= densitySwitchZoomLevel && mmaapp.getStyle().sprite.indexOf("mapbox://sprites/chen-maritimedatasystems-com/cjqi5artr0l4w2rogjrp7swa0") >= 0) {
      dispatch(updateUiProperty({ baseLayer: 'mapbox://styles/chen-maritimedatasystems-com/cjqi5v43u1gyv2rrrsom6t7i7' }));
      return;
    } else if (mmaapp.getZoom() < densitySwitchZoomLevel && mmaapp.getStyle().sprite.indexOf("mapbox://sprites/chen-maritimedatasystems-com/cjqi5v43u1gyv2rrrsom6t7i7") >= 0) {
      dispatch(updateUiProperty({ baseLayer: 'mapbox://styles/chen-maritimedatasystems-com/cjqi5artr0l4w2rogjrp7swa0' }));
      return;
    }



    dispatch(fetchMapData({ boundingBox: mmaapp.getBounds(), filter:filterRef.current, ui: uiRef.current }))
 

  }

  useEffect(() => {
    if (mapRef.current !== null) {
      if (shipyardCoordinate.length > 0 && currentCompany.current && currentCompany.current.type === "SHIPYARD") {
        mapRef.current.flyTo({
          speed: 2,
          zoom: 8,
          center: shipyardCoordinate,
        })
        mapRef.current.fire('flystart');
      } else if (currentCompany.current.type !== "shipyard" && currentCompany.current.type !== "SHIPYARD") {
        mapRef.current.flyTo({
          speed: 2,
          zoom: 2,
          center: [0, 30],
        })
        mapRef.current.fire('flystart');
      }
    }
  }, [shipyardCoordinate])

  useEffect(() => {
    currentCompanyId.current = companyId;
    currentCompany.current = company
    fetchShipyardsData(companyId)
  }, [companyId])

  useEffect(() => {
    currentFullyLoaded.current = fullyLoad;
  }, [fullyLoad])



  useEffect(() => {
    if (document.querySelector("#tab-main-container") !== null && document.querySelector(".map-container-customized") !== null) {
      if (ui.currentView == "mapView") {
        document.querySelector(".map-container-customized").style.display = "";
        document.querySelector("#tab-main-container").style.display = "none";
      } else if (ui.currentView == "listView") {
        document.querySelector(".map-container-customized").style.display = "none";
        document.querySelector("#tab-main-container").style.display = "";
      }
    }

  }, [currentView])


  useEffect(() => {
    if (mapRef.current) {
      mapRef.current.flyTo({
        speed: 2,
        zoom: 12,
        center: flyToPosition,
      })
      mapRef.current.fire('flystart');
    }

  }, [flyToPosition])

  useEffect(() => {
    if (mapRef.current) {
      mapRef.current.fire('load');
    }
  }, [reloadMapDataSeq])

  useEffect(() => {
    if (mapRef.current) {
      mapRef.current.flyTo({
        speed: 2,
        zoom: 3,
        center: [10, 53.5],
      });
    }
  }, [portSearchId])

  useEffect(() => {
    if (mapRef.current) {
      if (currentSearchResult.features[0] && currentSearchResult.features[0].properties.type != "anchorage") {
        mapRef.current.flyTo({
          speed: 2,
          zoom: mapRef.current.getZoom() > flyToZoomLevel ? mapRef.current.getZoom() : flyToZoomLevel,
          center: currentSearchResult.features[0].geometry.coordinates,
        });
      } else if (currentSearchResult.features[0] && currentSearchResult.features[0].properties.type == "anchorage") {
        mapRef.current.flyTo({
          speed: 2,
          zoom: 10,
          center: currentSearchResult.features[0].geometry.coordinates,
        });
      }

    }
  }, [searchRequestSerial]);

  useEffect(() => {
    if (mapRef.current) {
      let bounds = currentMailingList.filter.mapBounds
      mapRef.current.fitBounds([[bounds.left, bounds.top], [bounds.right, bounds.bottom]]);
    }
  }, [currentMailingListSerial]);

  useEffect(() => {
    filterRef.current = filter
    uiRef.current = ui
    fleetRef.current = fleet
    currentFeatureRef.current = currentFeature
  }, [filter, ui, fleet, currentFeature]);

  useEffect(() => {
    filter.keyword= vesselDetail.detailValueForSearch
    dispatch(updateFilter({ filter: filterRef.current }))
  }, [vesselDetail]);


  useEffect(() => {
    if (mapRef.current) {
      mapRef.current.setStyle(baseLayer)
      mapChangeEvent(mapRef.current);
    }

    if (baseLayer === 'mapbox://styles/mapbox/outdoors-v11') {
      let echartslayer = new EchartsLayer(mapRef.current);
      echartsLayerRef.current = echartslayer;
    } else if (echartsLayerRef.current && echartsLayerRef.current._map) {
      echartsLayerRef.current.remove();
    }

  }, [baseLayer]);

  useEffect(() => {
    if (mapRef.current) {
      mapChangeEvent(mapRef.current);
    }
  }, [currentFilterSerial]);

  useEffect(() => {
    if (baseLayer === 'mapbox://styles/mapbox/outdoors-v11') {
      let series = [{
        type: 'lines',
        coordinateSystem: 'GLMap',
        polyline: true,
        data: mainTrackings,
        lineStyle: {
          opacity: 0.5,
          width: 1,
          normal: {
            "color": "rgba(0,0,0,0.1)"
          }
        },
        animation: false
      }, {
        type: 'lines',
        coordinateSystem: 'GLMap',
        polyline: true,
        data: mainTrackings,
        lineStyle: {
          width: 0,
        },
        effect: {
          constantSpeed: 50,
          show: true,
          trailLength: 0.5,
          symbolSize: 5,
          delay: 5,
        },
        zlevel: 1
      }]

      let option = {
        GLMap: {
          roam: true
        },
        coordinateSystem: 'GLMap',
        geo: {
          map: 'GLMap',
          label: {
            emphasis: {
              show: false
            }
          },
          roam: true,
          itemStyle: {
            normal: {
              areaColor: '#323c48',
              borderColor: '#404a59'
            },
            emphasis: {
              areaColor: '#2a333d'
            }
          }
        },
        series: series
      };

      echartsLayerRef.current.chart.setOption(option);
    }
  }, [vesselTrackingsRequestSerial]);



  useEffect(() => {
    if (mapRef.current) {

      if (!mapRef.current.getSource('vessel-position-data') || !mapRef.current.getSource('vessel-position-data')) {
        mapRef.current.loadImage('/img/logo.png', function (error, image) {
          if (error) throw error;
          if (!mapRef.current.hasImage('shipyard')) mapRef.current.addImage('shipyard', image);
        });

        mapRef.current.loadImage('/img/logoNewBuild.png', function (error, image) {
          if (error) throw error;
          if (!mapRef.current.hasImage('shipyardNewBuild')) mapRef.current.addImage('shipyardNewBuild', image);
        });

        mapRef.current.loadImage('/img/Workshop_Service.png', function (error, image) {
          if (error) throw error;
          if (!mapRef.current.hasImage('workshop')) mapRef.current.addImage('workshop', image);
        });
        mapRef.current.loadImage('/img/waste_circle.png', function (error, image) {
          if (error) throw error;
          if (!mapRef.current.hasImage('waste')) mapRef.current.addImage('waste', image);
        });
        mapRef.current.loadImage('/img/steel_circle.png', function (error, image) {
          if (error) throw error;
          if (!mapRef.current.hasImage('steel')) mapRef.current.addImage('steel', image);
        });
        mapRef.current.loadImage('/img/safety_circle.png', function (error, image) {
          if (error) throw error;
          if (!mapRef.current.hasImage('safety')) mapRef.current.addImage('safety', image);
        });
        mapRef.current.loadImage('/img/environmental_circle.png', function (error, image) {
          if (error) throw error;
          if (!mapRef.current.hasImage('environmental')) mapRef.current.addImage('environmental', image);
        });
        mapRef.current.loadImage('/img/underwater_circle.png', function (error, image) {
          if (error) throw error;
          if (!mapRef.current.hasImage('underwater')) mapRef.current.addImage('underwater', image);
        });

        mapRef.current.loadImage('/img/electrical_circle.png', function (error, image) {
          if (error) throw error;
          if (!mapRef.current.hasImage('electrical')) mapRef.current.addImage('electrical', image);
        });
        mapRef.current.loadImage('/img/FlagState_black.png', function (error, image) {
          if (error) throw error;
          if (!mapRef.current.hasImage('flagState')) mapRef.current.addImage('flagState', image);
        });
        mapRef.current.loadImage('/img/Classification_blackpng.png', function (error, image) {
          if (error) throw error;
          if (!mapRef.current.hasImage('classification')) mapRef.current.addImage('classification', image);
        });
        mapRef.current.loadImage('/img/Warehouse.png', function (error, image) {
          if (error) throw error;
          if (!mapRef.current.hasImage('warehouse')) mapRef.current.addImage('warehouse', image);
        });
        mapRef.current.loadImage('/img/Docking_Consulting.png', function (error, image) {
          if (error) throw error;
          if (!mapRef.current.hasImage('docking_consulting')) mapRef.current.addImage('docking_consulting', image);
        });
        mapRef.current.loadImage('/img/Engine.png', function (error, image) {
          if (error) throw error;
          if (!mapRef.current.hasImage('engine')) mapRef.current.addImage('engine', image);
        });
        mapRef.current.loadImage('/img/Port_Services_round.png', function (error, image) {
          if (error) throw error;
          if (!mapRef.current.hasImage('portService')) mapRef.current.addImage('portService', image);
        });
        mapRef.current.loadImage('/img/port.png', function (error, image) {
          if (error) throw error;
          if (!mapRef.current.hasImage('port')) mapRef.current.addImage('port', image);
        });

        if (!mapRef.current.hasImage('pulsing-dot')) {
          mapRef.current.addImage('pulsing-dot', pulsingDot, { pixelRatio: 2 });
        }

        mapRef.current.on('styleimagemissing', (e) => {
          const prefix = 'vessel-icon-';

          let imageName = e.id; // id of the missing image
          if (imageName.indexOf(prefix) === 0 && !mapRef.current.hasImage(imageName)) {
            const [vesselType, vesselSize, nextSurveyDays, moving] = imageName
              .replace(prefix, '')
              .split('-')
              .map(m => m);

            let scale = getVesselScale(vesselSize)
            const width = Math.ceil(16 * scale);
            const height = Math.ceil(78 * scale);
            let data = createMissingImage(imageName, width, height, prefix, scale);
            mapRef.current.addImage(imageName, { width, height, data });
          }
        });

        if (mapRef.current.isStyleLoaded()) {



          mapRef.current.addSource("vessel-polygon-data", {
            type: "geojson",
            data: vesselPolygon
          });

          mapRef.current.addLayer({
            id: "vessel-polygon-layer",
            source: "vessel-polygon-data",
            'type': 'fill',
            'layout': {},
            'paint': {
              'fill-color': '#009688',
              'fill-opacity': 0.8
            }
          });

          mapRef.current.addSource("shipyard-area-polygon-data", {
            "type": "geojson",
            "data": companyAreas
          });

          mapRef.current.addLayer({
            "id": "shipyard-area-polygon-layer",
            "source": "shipyard-area-polygon-data",
            'type': 'fill',
            'layout': {},
            'paint': {
              'fill-color': 'red',
              'fill-opacity': 0.3,
              'fill-antialias': true,
              'fill-outline-color': 'red'
            }
          });

          mapRef.current.addSource("shipyard-dock-polygon-data", {
            "type": "geojson",
            "data": companyDocks
          });

          mapRef.current.addLayer({
            "id": "shipyard-dock-polygon-layer",
            "source": "shipyard-dock-polygon-data",
            'type': 'fill',
            'layout': {},
            'paint': {
              'fill-color': 'blue',
              'fill-opacity': 0.3,
              'fill-antialias': true,
              'fill-outline-color': 'blue'
            }
          });

          mapRef.current.addSource("anchorage-polygon-data", {
            type: "geojson",
            data: anchorageAreaPolygon
          });

          mapRef.current.addLayer({
            id: "anchorage-polygon-layer",
            source: "anchorage-polygon-data",
            'type': 'fill',
            'layout': {},
            'paint': {
              'fill-color': '#009688',
              'fill-opacity': 0.8
            }
          });

          mapRef.current.addSource("vessel-position-data", {
            type: "geojson",
            data: vesselPosition
          });

          mapRef.current.addLayer({
            id: "vessel-position-layer",
            source: "vessel-position-data",
            type: "symbol",
            layout: {
              'icon-image': ['concat', 'vessel-icon-', ['get', 'vessel_type'], '-', ['get', 'size'], '-', ['get', 'inSurveyDays'], '-', ['get', 'moving']],
              'icon-rotate': ['get', 'heading'],
              'text-allow-overlap': true,
              'icon-allow-overlap': true,
            }
          });


          mapRef.current.addSource("shipyards-data", {
            type: "geojson",
            data: shipyards
          });

          mapRef.current.addLayer({
            id: "shipyards-layer",
            source: "shipyards-data",
            type: "symbol",
            layout: {
              'icon-size': 0.6,
              'icon-image': 'shipyard',
              'text-allow-overlap': true,
              'icon-allow-overlap': true,
            }
          });

          mapRef.current.addSource("shipyardsWatchList-data", {
            type: "geojson",
            data: shipyardsWatchList
          });

          mapRef.current.addLayer({
            id: "shipyardsWatchList-layer",
            source: "shipyardsWatchList-data",
            type: "symbol",
            layout: {
              'icon-size': 0.4,
              'icon-image': 'shipyard',
              'text-allow-overlap': true,
              'icon-allow-overlap': true,
            }
          });

          mapRef.current.addSource("port-data", {
            type: "geojson",
            data: port
          });
          mapRef.current.addLayer({
            id: "port-layer",
            source: "port-data",
            type: "symbol",
            layout: {
              'icon-size': 1,
              'icon-image': 'port',
              'text-allow-overlap': true,
              'icon-allow-overlap': true,
            }
          });

          mapRef.current.addSource("allShipyards-data", {
            type: "geojson",
            data: allShipyards
          });
          mapRef.current.addLayer({
            id: "allShipyards-layer",
            source: "allShipyards-data",
            type: "symbol",
            layout: {
              'icon-size': 0.6,
              'icon-image': 'shipyard',
              'text-allow-overlap': true,
              'icon-allow-overlap': true,
            }
          });

          mapRef.current.addSource("shipyards-new-build-data", {
            type: "geojson",
            data: newBuildShipyards
          });

          mapRef.current.addLayer({
            id: "shipyards-new-build-layer",
            source: "shipyards-new-build-data",
            type: "symbol",
            layout: {
              'icon-size': 0.4,
              'icon-image': 'shipyardNewBuild',
              'text-allow-overlap': true,
              'icon-allow-overlap': true,
            }
          });



          mapRef.current.addSource("vessel-tracking-data", {
            type: "geojson",
            data: vesselTracking
          });

          mapRef.current.addLayer({
            id: "vessel-tracking-layer",
            source: "vessel-tracking-data",
            'type': 'heatmap',
            'maxzoom': 9,
            'paint': {
              // Increase the heatmap color weight weight by zoom level
              // heatmap-intensity is a multiplier on top of heatmap-weight
              'heatmap-intensity': [
                'interpolate',
                ['linear'],
                ['zoom'],
                0,
                1,
                9,
                3
              ],
              // Color ramp for heatmap.  Domain is 0 (low) to 1 (high).
              // Begin color ramp at 0-stop with a 0-transparancy color
              // to create a blur-like effect.
              'heatmap-color': [
                'interpolate',
                ['linear'],
                ['heatmap-density'],
                0, 'rgba(229,	244	,243, 0.1)',
                0.2, 'rgba(	204,	234,	231, 0.3)',
                0.4, 'rgba(153,	213,	207, 0.5)',
                0.6, 'rgba(102,	192,	183, 0.7)',
                0.8, 'rgba(	50,	171,	159, 0.9)'
              ],
              // Adjust the heatmap radius by zoom level
              'heatmap-radius': [
                'interpolate',
                ['linear'],
                ['zoom'],
                15,
                30
              ],
              // Transition from heatmap to circle layer by zoom level
              'heatmap-opacity': {
                default: 1,
                stops: [
                  [14, 1],
                  [15, 0]
                ]
              },
            }
          }
          );

          mapRef.current.addSource("underwater-service-data", {
            type: "geojson",
            data: underwater
          });
          mapRef.current.addLayer({
            id: "underwater-service-layer",
            source: "underwater-service-data",
            type: "symbol",
            layout: {
              'icon-size': 0.1,
              'icon-image': 'underwater',
              'text-allow-overlap': true,
              'icon-allow-overlap': true,
            }
          });
          mapRef.current.addSource("waste-service-data", {
            type: "geojson",
            data: classification
          });
          mapRef.current.addLayer({
            id: "waste-service-layer",
            source: "waste-service-data",
            type: "symbol",
            layout: {
              'icon-size': 0.1,
              'icon-image': 'waste',
              'text-allow-overlap': true,
              'icon-allow-overlap': true,
            }
          });
          mapRef.current.addSource("workshop-service-data", {
            type: "geojson",
            data: workshop
          });
          mapRef.current.addLayer({
            id: "workshop-service-layer",
            source: "workshop-service-data",
            type: "symbol",
            layout: {
              'icon-size': 0.1,
              'icon-image': 'workshop',
              'text-allow-overlap': true,
              'icon-allow-overlap': true,
            }
          });
          mapRef.current.addSource("steel-service-data", {
            type: "geojson",
            data: steel
          });
          mapRef.current.addLayer({
            id: "steel-service-layer",
            source: "steel-service-data",
            type: "symbol",
            layout: {
              'icon-size': 0.1,
              'icon-image': 'steel',
              'text-allow-overlap': true,
              'icon-allow-overlap': true,
            }
          });
          mapRef.current.addSource("safety-service-data", {
            type: "geojson",
            data: safety
          });
          mapRef.current.addLayer({
            id: "safety-service-layer",
            source: "safety-service-data",
            type: "symbol",
            layout: {
              'icon-size': 0.1,
              'icon-image': 'safety',
              'text-allow-overlap': true,
              'icon-allow-overlap': true,
            }
          });
          mapRef.current.addSource("electrical-service-data", {
            type: "geojson",
            data: electrical
          });
          mapRef.current.addLayer({
            id: "electrical-service-layer",
            source: "electrical-service-data",
            type: "symbol",
            layout: {
              'icon-size': 0.1,
              'icon-image': 'electrical',
              'text-allow-overlap': true,
              'icon-allow-overlap': true,
            }
          });
          mapRef.current.addSource("environmental-service-data", {
            type: "geojson",
            data: environmental
          });
          mapRef.current.addLayer({
            id: "environmental-service-layer",
            source: "environmental-service-data",
            type: "symbol",
            layout: {
              'icon-size': 0.1,
              'icon-image': 'environmental',
              'text-allow-overlap': true,
              'icon-allow-overlap': true,
            }
          });


          mapRef.current.addSource("flagState-service-data", {
            type: "geojson",
            data: flagState
          });
          mapRef.current.addLayer({
            id: "flagState-service-layer",
            source: "flagState-service-data",
            type: "symbol",
            layout: {
              'icon-size': 0.1,
              'icon-image': 'flagState',
              'text-allow-overlap': true,
              'icon-allow-overlap': true,
            }
          });
          mapRef.current.addSource("classification-service-data", {
            type: "geojson",
            data: classification
          });
          mapRef.current.addLayer({
            id: "classification-service-layer",
            source: "classification-service-data",
            type: "symbol",
            layout: {
              'icon-size': 0.1,
              'icon-image': 'classification',
              'text-allow-overlap': true,
              'icon-allow-overlap': true,
            }
          });
          mapRef.current.addSource("warehouse-service-data", {
            type: "geojson",
            data: warehouse
          });
          mapRef.current.addLayer({
            id: "warehouse-service-layer",
            source: "warehouse-service-data",
            type: "symbol",
            layout: {
              'icon-size': 0.1,
              'icon-image': 'warehouse',
              'text-allow-overlap': true,
              'icon-allow-overlap': true,
            }
          });
          mapRef.current.addSource("docking_consulting-service-data", {
            type: "geojson",
            data: docking_consulting
          });
          mapRef.current.addLayer({
            id: "docking_consulting-service-layer",
            source: "docking_consulting-service-data",
            type: "symbol",
            layout: {
              'icon-size': 0.1,
              'icon-image': 'docking_consulting',
              'text-allow-overlap': true,
              'icon-allow-overlap': true,
            }
          });


          mapRef.current.addSource("engine-service-data", {
            type: "geojson",
            data: engine
          });
          mapRef.current.addLayer({
            id: "engine-service-layer",
            source: "engine-service-data",
            type: "symbol",
            layout: {
              'icon-size': 0.1,
              'icon-image': 'engine',
              'text-allow-overlap': true,
              'icon-allow-overlap': true,
            }
          });

          mapRef.current.addSource("portService-service-data", {
            type: "geojson",
            data: portService
          });
          mapRef.current.addLayer({
            id: "portService-service-layer",
            source: "portService-service-data",
            type: "symbol",
            layout: {
              'icon-size': 0.1,
              'icon-image': 'portService',
              'text-allow-overlap': true,
              'icon-allow-overlap': true,
            }
          });




          mapRef.current.addSource("vessel-route-data", {
            type: "geojson",
            data: vesselRoute
          });

          mapRef.current.addLayer({
            id: "vessel-route-layer",
            source: "vessel-route-data",
            'type': 'line',
            'layout': {
            },
            'paint': {
              'line-width': 4,
              'line-color': '#005996',
              'line-dasharray': [3, 3],
            }
          });

          mapRef.current.addLayer({
            "id": "vessel-route-symbol-layer",
            "type": "symbol",
            "source": "vessel-route-data",
            "layout": {
              "symbol-placement": "line",
              "text-allow-overlap": true,
              "text-field": ['concat', ['get', 'destination'], ' | ', ['get', 'distance'], ' | ', ['get', 'eta']],
              "text-offset": [0, -1]
            }
          });



        }

        // Create a popup, but don't add it to the map yet.
        let popup = new mapboxgl.Popup({
          closeButton: false,
          closeOnClick: false,
          maxWidth: 'none'
        });

        let detailPopup = new mapboxgl.Popup({
          closeButton: true,
          closeOnClick: false,
          className: 'scollable'
        });

        detailPopupRef.current = detailPopup;

        let mousemoveFunc = (e) => {
          let f = mapRef.current.queryRenderedFeatures(e.point)[0];
          if (f.properties.id !== lastFeature) {
            setLastFeature(f.properties.id);

            mapRef.current.getCanvas().style.cursor = 'pointer';

            let coordinates = turf.center(f.geometry).geometry.coordinates.slice();
            let description = getPopupContent(f.properties, vesselsInAnchorage);

            // Ensure that if the map is zoomed out such that multiple
            // copies of the feature are visible, the popup appears
            // over the copy being pointed to.
            while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
              coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
            }

            // Populate the popup and set its coordinates
            // based on the feature found.
            if (!detailPopup.isOpen() || (currentFeatureRef.current.properties.id !== f.properties.id)) {
              popup
                .setLngLat(coordinates)
                .setHTML(description)
                .addTo(mapRef.current);
            }
          }
        }

        let mouseLeaveFunc = () => {
          mapRef.current.getCanvas().style.cursor = '';
          popup.remove();
        }

        let clickFunc = (e) => {
          popup.remove();
          detailPopup.remove();
          if (e.features[0].properties.type === "shipyard") {
            mapRef.current.flyTo({
              speed: 2,
              zoom: mapRef.current.getZoom() > flyToZoomLevel ? mapRef.current.getZoom() : flyToZoomLevel,
              center: e.features[0].geometry.coordinates,
            });
          }

          dispatch(updateMapProperty({ currentFeature: e.features[0], filter: filterRef.current }))
          dispatch(removeRoute())

          let coordinates = turf.center(e.features[0].geometry).geometry.coordinates.slice();

          // Ensure that if the map is zoomed out such that multiple
          // copies of the feature are visible, the popup appears
          // over the copy being pointed to.
          while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
            coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
          }
          const placeholder = document.createElement('div');
          ReactDOM.render(<Provider store={store}><PreviewProperty filter={filterRef.current} /></Provider>, placeholder);
          detailPopup
            .setLngLat(coordinates)
            .setDOMContent(placeholder)
            .addTo(mapRef.current);
        }

        ['vessel-position-layer', 'vessel-polygon-layer', 'shipyards-layer', 'shipyardsWatchList-layer', 'port-layer', 'allShipyards-layer', 'shipyards-new-build-layer', 'underwater-service-layer', 'environmental-service-layer', 'electrical-service-layer', 'safety-service-layer', 'steel-service-layer', 'waste-service-layer', 'workshop-service-layer', 'engine-service-layer', 'docking_consulting-service-layer', 'warehouse-service-layer', 'classification-service-layer', 'flagState-service-layer', 'portService-service-layer'].map((layer) => {
          mapRef.current.on('mouseleave', layer, mouseLeaveFunc);
          mapRef.current.on('mousemove', layer, mousemoveFunc);
          mapRef.current.on('click', layer, clickFunc);
        });

      } else {
        mapRef.current.getSource('vessel-position-data').setData(vesselPosition);
        mapRef.current.getSource('vessel-route-data').setData(vesselRoute);
        mapRef.current.getSource('vessel-tracking-data').setData(vesselTracking);
        mapRef.current.getSource('vessel-polygon-data').setData(vesselPolygon);
        mapRef.current.getSource('shipyards-data').setData(shipyards);
        mapRef.current.getSource('shipyardsWatchList-data').setData(shipyardsWatchList);
        mapRef.current.getSource('shipyards-new-build-data').setData(newBuildShipyards);
        mapRef.current.getSource('underwater-service-data').setData(underwater);
        mapRef.current.getSource('waste-service-data').setData(waste);
        mapRef.current.getSource('workshop-service-data').setData(workshop);
        mapRef.current.getSource('steel-service-data').setData(steel);
        mapRef.current.getSource('safety-service-data').setData(safety);
        mapRef.current.getSource('electrical-service-data').setData(electrical);
        mapRef.current.getSource('environmental-service-data').setData(environmental);
        mapRef.current.getSource('flagState-service-data').setData(flagState);
        mapRef.current.getSource('classification-service-data').setData(classification);
        mapRef.current.getSource('warehouse-service-data').setData(warehouse);
        mapRef.current.getSource('docking_consulting-service-data').setData(docking_consulting);
        mapRef.current.getSource('port-data').setData(port);
        mapRef.current.getSource('allShipyards-data').setData(allShipyards);
        mapRef.current.getSource('engine-service-data').setData(engine);
        mapRef.current.getSource('portService-service-data').setData(portService);
        if (zoom > 12) {
          mapRef.current.getSource('shipyard-area-polygon-data').setData(companyAreas);
          mapRef.current.getSource('shipyard-dock-polygon-data').setData(companyDocks);
        }
      }
    }
  }, [requestSerial]);

  useEffect(() => {
    let flying = false;
    const map = new mapboxgl.Map({
      container: mapContainerRef.current,
      // See style options here: https://docs.mapbox.com/api/maps/#styles
      style: 'mapbox://styles/mapbox/streets-v11',
      center: [-38, 38],
      zoom: 2,
      maxZoom: 18,
    });

    // add navigation control (the +/- zoom buttons)
    map.addControl(new mapboxgl.NavigationControl({ showCompass: false }), 'top-left');
    map.dragRotate.disable();
    map.touchZoomRotate.disableRotation();

    map.addControl(new RulerControl({
      labelFormat: n => `${(n / 1.852).toFixed(0)}NM/${n.toFixed(0)}km`,
    }), 'top-left');
    map.on('load', function () {
      dispatch(changeMapZoom(map.getZoom()))
      map.resize();
      mapChangeEvent(map);
    });
    map.on("moveend", () => {
      mapChangeEvent(map);
      if (flying && !currentFullyLoaded.current) {
        map.fire('flyend');
      }

    });




    mapRef.current = map
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="map-container" style={{ position: "relative" }}>
      <div id="main-map" className="map" ref={mapContainerRef} style={{ height: "650px" }} />
      <div id="custom-legend" className="legend">
        <h4>Map layer</h4>
        <input type="radio" checked={baseLayer === 'mapbox://styles/mapbox/streets-v11'} name="baseLayer" style={{ position: "unset", left: "unset" }}
          onChange={(e) => {
            dispatch(updateUiProperty({ baseLayer: 'mapbox://styles/mapbox/streets-v11' }));
          }}
        /> Light Map
        <br />
        <input type="radio" checked={baseLayer === 'mapbox://styles/mapbox/dark-v10'} name="baseLayer" style={{ position: "unset", left: "unset" }}
          onChange={(e) => {
            dispatch(updateUiProperty({ baseLayer: 'mapbox://styles/mapbox/dark-v10' }));
          }}
        /> Dark Map
        <br />
        <input type="radio" checked={baseLayer === 'mapbox://styles/mapbox/satellite-v9'} name="baseLayer" style={{ position: "unset", left: "unset" }}
          onChange={(e) => {
            dispatch(updateUiProperty({ baseLayer: 'mapbox://styles/mapbox/satellite-v9' }));
          }}
        /> Satellite Map
        <br />
        <input type="radio" checked={baseLayer.indexOf('mapbox://styles/chen-maritimedatasystems-com') >= 0} name="baseLayer" style={{ position: "unset", left: "unset" }}
          onChange={(e) => {
            if (mapRef.current.getZoom() >= densitySwitchZoomLevel) {
              dispatch(updateUiProperty({ baseLayer: 'mapbox://styles/chen-maritimedatasystems-com/cjqi5v43u1gyv2rrrsom6t7i7' }));
            } else if (mapRef.current.getZoom() < densitySwitchZoomLevel) {
              dispatch(updateUiProperty({ baseLayer: 'mapbox://styles/chen-maritimedatasystems-com/cjqi5artr0l4w2rogjrp7swa0' }));
            }
          }}
        /> Density Map
        <br />
        <br />
        <h4>Class Expires</h4>
        <div><span style={{ border: 'solid 3px red' }}></span>&lt; 6 months</div>
        <br />
        <h4>Moving status</h4>
        <div><span style={{ border: 'solid 3px #009688', borderRadius: '5px' }}></span>Not Moving</div>
        <br />
        <h4>Vessel types</h4>
        {
          allVesselTypes.map(t => {
            return (
              <div key={t}><span style={{ backgroundColor: getVesselColorByType(t) }}></span>{_.startCase(_.toLower(t))}</div>
            )
          })
        }
      </div>
    </div>
  );
}

export default MapContainer;